import { getPlatformInfo } from "../../utils/utility";
import IphoneInstructionPopup from "./IphoneInstructionPopup";
import IphoneStandAlone from "./IphoneStandAlone";
import { useContext, useEffect, useState } from "react";
import NonIphoneLightShow from "./NonIphoneLightShow";
import LightShowMobileWeb from "./LightShowMobileWeb";
import { uvenuFetcher } from "../../utils/uvenu-fetcher";
import { PUBLIC_BASE_URL, URLS } from "../../constants";
import Loader from "../../components/Loader/Loader";
import { useParamsFromUrlFragment } from "../JoinEventLive/MainScreenWithTabs/useParamsFromUrlFragmet";
import { AppContext } from "../../contexts/App.Context";
import { insights } from "../../ApplicationInsightsService";
import "./JoinLightShow.css";
import { Place } from "@mui/icons-material";
const mainContainerClass =
  "bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors duration-300 absolute inset-0 flex items-center justify-center p-4";
const JoinLightshow = () => {
  const appContext = useContext(AppContext);
  const pageParams = useParamsFromUrlFragment();
  const [isIphone, setIsIphone] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [showMainContent, setShowMainContent] = useState(false);
  const [needsPermission, setNeedsPermission] = useState(false);
  const [loading, setLoading] = useState(true);

  const [isAtLocation, setIsAtLocation] = useState(null);
  const [event_id, setEventId] = useState(pageParams?.eventId);
  const [appIcon, setAppIcon] = useState(null);
  const [isLightshowStreaming, setIsLightshowStreaming] = useState(false);

  useEffect(() => {
    const platformInfo = getPlatformInfo();
    setIsIphone(platformInfo.isIOS);
    setIsStandalone(window.matchMedia("(display-mode: standalone)").matches);

    const checkSubscription = async () => {
      if ("serviceWorker" in navigator) {
        try {
          const registration = await navigator.serviceWorker.ready;
          const subscription = await registration.pushManager.getSubscription();
          if (subscription) {
            const response = await uvenuFetcher({
              url: `${PUBLIC_BASE_URL}/notifications/check-subscription`,
              method: "POST",
              body: {
                endpoint: subscription.endpoint,
              },
              headers: { "Content-Type": "application/json" },
            });
            if (!response?.json?.exists) {
              setNeedsPermission(true);
              setShowMainContent(false);
            }
          } else {
            setNeedsPermission(true);
            setShowMainContent(false);
          }
        } catch (error) {
          console.error("Error checking subscription:", error);
          setNeedsPermission(true);
          setShowMainContent(false);
        } finally {
          setLoading(false);
        }
      }
    };

    checkSubscription();
  }, []);

  const getNearestEventData = async (latitude, longitude) => {
    if (!latitude || !longitude) {
      appContext.triggerToast(true, {
        type: "error",
        message:
          "To participate in the event experience, you must allow location services. Please review and restart the session.",
      });
      return;
    }
    setLoading(true);
    const eventResponse = await uvenuFetcher({
      url: URLS.GET_NEARBY_EVENT(latitude, longitude),
      method: "GET",
    });
    setLoading(false);
    if (eventResponse.statusCode === 200) {
      setEventId(eventResponse.json.data.event._id);

      setIsAtLocation(true);
    } else {
      appContext.triggerToast(true, {
        type: "error",
        message:
          "To participate in the event experience, you must be at the event location.",
      });
      setIsAtLocation(false);
      let error = Error(eventResponse.json.message);
      insights.trackUvenuException(error, {
        status: "failed",
        message: eventResponse.json.message,
        coordinates: {
          latitude: latitude,
          longitude: longitude,
        },
      });
    }
  };
  const getLatLong = async () => {
    try {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          getNearestEventData(
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (error) => {
          console.log("not getting location: ", error);
          let message =
            "To participate in the event experience, you must allow location services. Please review and restart the session.\n";
          if (window.navigator.platform.toLowerCase().startsWith("li")) {
            message =
              message +
              "Go to Settings >> Chrome/Browser >> Search for Location Services >> set permission to Allow";
          } else {
            message =
              message +
              '-Open "Settings."\n-Go to "Privacy & Security."\n-Enable "Location Services."\n-Find "Safari/Chrome" on the list.\n-Set access to "While Using the App."';
          }
          alert(message);
          insights.trackUvenuException(error, {
            status: "error",
            info: "JoinLightShow: Exception in fetching location from device due to permissions",
            error: error,
          });
        }
      );
    } catch (error) {
      insights.trackUvenuException(error, {
        status: "error",
        info: "JoinLightShow: Unhandled Exception in fetching location from device due to permissions",
        error: error,
      });
    }
  };

  useEffect(() => {
    if (event_id) {
      fetch(`${PUBLIC_BASE_URL}/event/${event_id}/manifest.json`)
        .then((response) => response.json())
        .then((manifest) => {
          // Handle the fetched manifest data
          const isLightshowStreaming = manifest?.isLightshowStreaming
            ? true
            : false;
          manifest.start_url = `${window.location.origin}${manifest.start_url}`;
          manifest.scope = `${window.location.origin}${manifest.scope}`;

          // Remove existing apple-touch-icon links
          document
            .querySelectorAll('link[rel="apple-touch-icon"]')
            .forEach((e) => e.remove());
          setAppIcon(null);

          // Create link elements for icons on iOS
          manifest.icons.forEach((icon) => {
            if (icon.src && icon.sizes) {
              let linkElement = document.createElement("link");
              linkElement.setAttribute("rel", "apple-touch-icon");
              linkElement.setAttribute("sizes", icon.sizes);
              linkElement.setAttribute("href", icon.src);
              document.querySelector("head").appendChild(linkElement);
              if (icon.sizes === "512x512") {
                setAppIcon(icon.src);
              }
            }
          });

          // Create or update the manifest link
          if (manifest?.isLightshowStreaming !== undefined) {
            delete manifest.isLightshowStreaming;
          }
          let content = encodeURIComponent(JSON.stringify(manifest));
          let url = "data:application/manifest+json," + content;
          let element = document.querySelector('link[rel="manifest"]');
          if (element) {
            element.setAttribute("href", url);
          } else {
            element = document.createElement("link");
            element.setAttribute("rel", "manifest");
            element.setAttribute("href", url);
            document.querySelector("head").appendChild(element);
          }

          setIsLightshowStreaming(isLightshowStreaming);
        })
        .catch((error) => {
          console.error("Error fetching manifest:", error);
        });
    } else {
      getLatLong();
    }
  }, [event_id]);

  useEffect(() => {
    if (showMainContent) {
      setNeedsPermission(false);
    }
  }, [showMainContent]);

  if (loading) {
    return (
      <div className={mainContainerClass}>
        <Loader spinner={true} />
      </div>
    );
  }

  if (!isAtLocation && !event_id) {
    return (
      <div className={mainContainerClass}>
        <section class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow space-y-4 flex flex-col items-center justify-center">
          <Place className="text-black" fontSize="large" />
          <p class="text-center muted-text">
            To participate in an event, you must be at the event location.
          </p>
        </section>
      </div>
    );
  }
  if (isLightshowStreaming) {
    return (
      <div className={mainContainerClass}>
        <LightShowMobileWeb eventIdfromPageParams={event_id} />
      </div>
    );
  }

  if (showMainContent) {
    return (
      <div className={mainContainerClass}>
        <LightShowMobileWeb eventIdfromPageParams={event_id} />
      </div>
    );
  }
  if (isIphone) {
    if (isStandalone) {
      return (
        <div className={mainContainerClass}>
          <IphoneStandAlone
            onShowMainContent={() => setShowMainContent(true)}
            eventId={event_id}
            needsPermission={needsPermission}
            appIcon={appIcon}
          />
        </div>
      );
    } else {
      return (
        <div className={mainContainerClass}>
          <IphoneInstructionPopup
            appIcon={appIcon}
            onContinueHere={() => {
              setShowMainContent(true);
            }}
          />
        </div>
      );
    }
  } else {
    return (
      <div className={mainContainerClass}>
        <NonIphoneLightShow
          onShowMainContent={() => setShowMainContent(true)}
          eventId={event_id}
          needsPermission={needsPermission}
          appIcon={appIcon}
        />
      </div>
    );
  }
};
export default JoinLightshow;
